/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tiny_Caring_Hyena_ShineInputs */

const en_tiny_caring_hyena_shine = /** @type {(inputs: Tiny_Caring_Hyena_ShineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Administration Area`)
};

const de_tiny_caring_hyena_shine = /** @type {(inputs: Tiny_Caring_Hyena_ShineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adminstration`)
};

/**
* | output |
* | --- |
* | "Administration Area" |
*
* @param {Tiny_Caring_Hyena_ShineInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tiny_caring_hyena_shine = /** @type {((inputs?: Tiny_Caring_Hyena_ShineInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tiny_Caring_Hyena_ShineInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tiny_caring_hyena_shine(inputs)
	return de_tiny_caring_hyena_shine(inputs)
});